<template>
    <div class="login-page page">
        <div class="login-form">
            <h1>Billing | Disruptive Art </h1>
            <hr class="mb-4" />
            
            <div class="buttons service-logins">
                <v-btn
                    @click="login('microsoft')"
                    class="is-primary is-fullwidth">
                    <img class="brand-logo" :src="msLogoSrc" /> Microsoft
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  methods: {
    async login(service) {
      switch(service) {
        case 'microsoft': {
          try {
            const result = await this.$axios.get('/oauth/redirect?service=microsoft');
            window.location = result.data.url;
          } catch (e) {
            //
          }

          return;
        }
      }
    }
  },
  beforeMount() {
    this.$store.commit("ADD_APP_CLASSES", ['login-body-page']);
  },
  computed: {
    msLogoSrc() {
      return require('@/assets/imgs/windows_logo.png');
    }
  }
}

// import Vue from 'vue';
// import axios from 'axios';

// export default Vue.extend({
//     data() {
//         return {
//             form: {
//                 email: '',
//                 password: ''
//             },
//             isSubmitting: false,
//             errorMessage: null
//         }
//     },
//     mounted() {
//         if (this.$store.state.account) {
//             this.$router.replace("/");
//             return;
//         }

//         this.$store.commit("ADD_APP_CLASSES", ['login-body-page']);
//     },
//     methods: {
//         async login() {
//             if (this.isSubmitting) {
//                 return;
//             }

//             this.isSubmitting = true;
//             this.errorMessage = null;

//             try {
//                 const result = await axios.post("/login", this.form);
//                 this.$store.commit("ACCOUNT", result.data);
//                 axios.defaults.headers.Authorization = `Bearer ${result.data.token}`;

//                 this.$router.replace('/');
//             } catch (e) {
//                 if (e.response) {
//                     if (e.response.status === 404) {
//                         this.errorMessage = "User doesn't exist";
//                     }
//                 }
//             }

//             this.isSubmitting = false;
//         }
//     }
// });
</script>